module.exports = "/_next/static/images/Homes-2706669c75b11f179e7ff85df7d70c05.jpg";